export default "__VITE_ASSET__CJ1$Euk6__"